module.exports = __webpack_public_path__ + "static/media/MT5.87e98977.mp3";